import { IAreaQuery } from "../../models/area/query";
import { IArea, IAreaDetails } from "../../models/area/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import {IInternalState, AppsLoading} from "./context";
import App from "../../App";
import {IApps} from "../../models/apps/response";

type Action =
    | { type: "LOADING"; payload: { loading: AppsLoading | AppsLoading[] } }
    | { type: "SET_LIST"; payload: { list: any } }

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }


    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
